var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fade-transition',[(_vm.isLoading)?_c('v-overlay',{attrs:{"absolute":"","color":"#181717"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey lighten-5"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }